const SESSION_STORAGE_KEY = "inkredible_retail_v1";

export function addToCart(product) {
  // Get saved data from sessionStorage
  const currentCart = getCart();
  const item = product[Object.keys(product)[0]];
  const cartSku = Object.keys(product)[0];

  if (currentCart) {
    const isAlreadythere = currentCart[cartSku] ? true : false;
    if (isAlreadythere) {
      currentCart[cartSku].quantity =
        parseInt(currentCart[cartSku].quantity, 10) +
        parseInt(item.quantity, 10);
      setCart(currentCart);
    } else {
      setCart(Object.assign({}, currentCart, product));
    }
  } else {
    setCart(product);
  }
}

export function getCart() {
  const sessionKey = `${SESSION_STORAGE_KEY}_cart`;
  return JSON.parse(window.sessionStorage.getItem(sessionKey));
}

export function noOfItemsInCart() {
  const cart = getCart() || {};
  const noOfitems = Object.keys(cart).length;
  return `Cart (${noOfitems} Items)`;
}

function setCart(item) {
  const sessionKey = `${SESSION_STORAGE_KEY}_cart`;
  return sessionStorage.setItem(sessionKey, JSON.stringify(item));
}
